// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__10Yge","left":"InfoRow_left__2V69N"};